import { disablePageScroll, enablePageScroll } from 'scroll-lock'

export default function () {
  return {
    mounted(el, binding) {
      if (binding.value === false) {
        el._scrollLockDisabled = true
        return
      }

      disablePageScroll(el)
    },
    unmounted(el) {
      if (el._scrollLockDisabled) return

      enablePageScroll(el)
    }
  }
}
